import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import PersonIcon from '@material-ui/icons/Person'
import GridOnIcon from '@material-ui/icons/GridOn'
import PaymentIcon from '@material-ui/icons/Payment'
import FavoriteIcon from '@material-ui/icons/Favorite'
import { makePath } from '../../../lib'
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'

const styles = {
}

const SettingsMenuItems = withStyles(styles, { withTheme: true })((props) => {
  const { classes } = props

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const menuItemPropsList = [
    {
      name: 'userInfo',
      menuItemProps: {
        component: Link,
        to: makePath('/settings/account', language)
      },
      listItemTextProps: {
        primary: (<Word wid={WID.SETTINGS_MENU_ITEMS.USER_INFORMATION}/>),
      },
      icon: <PersonIcon/>,
    },
    {
      name: 'renjuBoard',
      menuItemProps: {
        component: Link,
        to: makePath('/settings/board', language)
      },
      listItemTextProps: {
        primary: (<Word wid={WID.SETTINGS_MENU_ITEMS.RENJU_BOARD}/>),
      },
      icon: <GridOnIcon/>,
    },
    {
      name: 'payment',
      menuItemProps: {
        component: Link,
        to: makePath('/settings/payment', language)
      },
      listItemTextProps: {
        primary: (<Word wid={WID.SETTINGS_MENU_ITEMS.PAYMENT}/>),
      },
      icon: <PaymentIcon/>,
    },
    {
      name: 'donation',
      menuItemProps: {
        component: Link,
        to: makePath('/settings/donation', language)
      },
      listItemTextProps: {
        primary: (<Word wid={WID.SETTINGS_MENU_ITEMS.DONATION}/>),
      },
      icon: <FavoriteIcon/>,
    }
  ]

  const handleClick = (name) => (event) => {
    if (props.onClose) {
      props.onClose(name)
    }
  }
  
  return (
    <React.Fragment>
      {menuItemPropsList.map((itemProps, index) => 
        <MenuItem key={index} className={classes.menuItem} {...itemProps.menuItemProps} onClick={handleClick(itemProps.name)}>
          <ListItemIcon className={classes.icon}>
            {itemProps.icon}
          </ListItemIcon>
          <ListItemText inset {...itemProps.listItemTextProps}/>
        </MenuItem>
      )}
    </React.Fragment>
  )
})

export default SettingsMenuItems


// WEBPACK FOOTER //
// ./src/Pages/Settings/components/SettingsMenuItems.js